/** Clerk user id allowed to manage site content. Must match `AUTHORIZED_USER_ID` in convex/auth.ts. */
export const AUTHORIZED_USER_ID = "user_2yeq7o5pXddjNeLFDpoz5tTwkWS"
